<template>
    <main>
       <div class="container-fluid">
             <div class="mainButton">
                <div class="row">
                    <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <!-- <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-end">
                        <DownloadAction v-if="downloadAction" ref="loaddownload"></DownloadAction>
                    </div> -->
                </div>
             </div>
             <div class="page-toolbar">
                <div class="page-title">
                    <span class="title">Detail Budget Subhead</span> 
                    <span class="star"> <i class="fa-solid fa-star"></i></span>
                </div>
            </div>
        </div>

        <GenericDetail v-if="generic" ref="loadGeneric"> </GenericDetail>

        <GenericMoreButton v-if="genericBtn" ref="loadgenericbtn"></GenericMoreButton>
        <CustomMoreButton v-else></CustomMoreButton>

    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/BudgetSubHeads/MenuList.vue";
    import lang from "@/views/modules/BudgetSubHeads/language/en";
    import GenericDetail from "@/components/layout/shared/generic/DetailView.vue";
    import GenericMoreButton from "@/components/layout/shared/generic/common/MoreButton.vue";
    import CustomMoreButton from "@/views/modules/BudgetSubHeads/MoreButton.vue";
    import DownloadAction from "@/components/layout/shared/generic/download/Download.vue";

    export default {
        name: "new-example",
        components: {
            breadcrumbs,
            GenericDetail,
            CustomMoreButton,
            GenericMoreButton,
            DownloadAction
        },
        data() {
            return {
                generic: true,
                genericBtn: false,
                lang: [],
                metaList: [
                    {
                        name: 'col1',
                        items: [
                            {
                                name: 'budgethead_name',
                                label: lang.LBL_HEAD_NAME,
                                link: true,
                                routePath:'budgetheads',
                                related_id:'parent_id'
                            },
                            {
                                name: 'subhead_narration',
                                label: lang.LBL_SUBHEAD_NARRATION,
                                link: false,
                                routePath:'',
                                related_id:''
                            },
                            {
                            name:'is_changeable',
                            label: lang.LBL_IS_CHANGEABLE,
                            link: false,
                            routePath:'',
                            related_id:''
                            },
                        ]
                    },
                    {
                        name: 'col2',
                        items: [
                           
                            {
                                name: 'sequence_no',
                                label: lang.LBL_SEQUENCE_NO,
                                link: false,
                            },
                            
                        ]
                    },
                    {
                        name: 'col3',
                        items: [
                           
                            {
                                name: 'name',
                                label: lang.LBL_SUBHEAD_NAME,
                                link: false,
                            },
                            
                        ]
                    },
                    {
                        name: 'col4',
                        items: [
                            {
                                name: 'status',
                                label: lang.LBL_STATUS,
                                link: false,
                            },
                        ]
                    },
                ],
                moreBtn: [
                    {
                        id: 'edit',
                        path: 'budgetsubheads',
                        label: lang.LBL_EDIT,
                        action: 'edit',
                    },
                    {
                        id: 'delete',
                        path: 'budgetsubheads',
                        label: lang.LBL_DELETE,
                        action: 'delete',
                    },

                ],
                routePath: {
                    path: 'budgetsubheads',
                    detail: false
                },
                downloadAction: false,
                dowlloadList: [
                    {
                        label: lang.LBL_DOWNLOAD_ONE,
                        action: "/budgetsubheads/generate-pdf",
                        module: "Example",
                    },
                    {
                        label: lang.LBL_DOWNLOAD_TWO,
                        action: "",
                        module: "",
                    }
                ],
                record: null,
            }
        },
        mounted() {
            this.childMethod();
            this.lang = lang;
            this.showdowmload();
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
                if (this.genericBtn == true) {
                    this.$refs.loadgenericbtn.loadGenericBtn(this.moreBtn);
                }
            },
            showdowmload() {
                const self = this;
                if (self.downloadAction == true) {
                    this.$refs.loaddownload.loadDownloadView(self.dowlloadList);
                }
            }
        }
    }

</script>